/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  return async function onChange(next) {
    if (props.onChange) {
      props.onChange({
        filterData: next,
        ...(next.boards.length
          ? { board_ids: next.boards.map(board => board.id) }
          : {}),
        ...(next.locations.length
          ? { location_ids: next.locations.map(location => location.id) }
          : {}),
        ...(next.stages.length
          ? { stage_ids: next.stages.map(stage => stage.id) }
          : {}),
        ...(next.priorities.length
          ? { priorities: next.priorities.map(priority => priority.id) }
          : {}),
        ...(next.tags.length ? { tag_ids: next.tags.map(tag => tag.id) } : {}),
        ...(next.due_date ? { due_date: next.due_date } : {}),
        ...(next.assignees.length
          ? { assignee_ids: next.assignees.map(assignee => assignee.id) }
          : {}),
        ...(next.patients.length
          ? { patient_ids: next.patients.map(patient => patient.patient._id) }
          : {}),
        is_past_due_date: next.is_past_due_date,
      })
    }
  }
}
